<template>
  <div class="toast">
    <div class="close" @click="bindClose">取消</div>
    <div>
      <div class="address-title">填写收货信息</div>
      <div class="info-list">
        <div class="info-item">
          <div class="item-text">收货人</div>
          <div class="item-right">
            <input
              class="item-input"
              maxlength="50"
              v-model="addressData.user_name"
              type="text"
              placeholder="输入收货人名字"
            />
          </div>
        </div>
        <div class="info-item">
          <div class="item-text">联系电话</div>
          <div class="item-right">
            <input
              class="item-input"
              v-model="addressData.phone"
              maxlength="50"
              type="text"
              placeholder="输入联系电话"
            />
          </div>
        </div>
        <div class="info-item">
          <div class="item-text">收货地址</div>
          <div class="item-right">
            <textarea
              maxlength="255"
              class="item-input item-textarea"
              v-model="addressData.address"
              placeholder="输入详细地址"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="btn" @click="bindConfirm">确定</div>
    </div>
    <!--  <AppLoading class="loading" v-if="loading"></AppLoading> -->
  </div>
</template>

<script>
import AppLoading from '@/components/app/loading/loading.vue'
export default {
  components: { AppLoading },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      addressData: {
        user_name: '',
        phone: '',
        address: ''
      }
    }
  },
  computed: {},
  watch: {
    show() {
      if (this.show) {
        this.addressData = Object.assign({}, this.data)
      }
    }
  },
  created() {
    this.addressData = Object.assign({}, this.data)
  },
  methods: {
    bindConfirm() {
      if (!this.addressData.user_name) {
        this.$toast('收货人不能为空')
        return
      }
      if (!this.addressData.phone) {
        this.$toast('联系电话不能为空')
        return
      }
      if (!this.addressData.address) {
        this.$toast('收货地址不能为空')
        return
      }
      this.$emit('setAddress', this.addressData)
    },
    bindClose() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.toast {
  position: relative;
  z-index: 1;
  padding: 20px 20px 46px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 10px 10px 0px 0px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .close {
    position: absolute;
    right: 24px;
    top: 20px;
  }
  .address-title {
    font-weight: bold;
    font-size: 18px;
    color: #050b27;
    line-height: 25px;
    text-align: left;
    font-style: normal;
    margin-bottom: 40px;
  }
  .info-list {
    margin-bottom: 40px;
    .info-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;
      .item-text {
        padding-top: 10px;
        width: 66px;
        font-weight: bold;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.8);
        line-height: 20px;
      }
      .item-right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        .item-input {
          width: 100%;
          box-sizing: border-box;
          padding: 5px 11px;
          outline: none;
          border: none;
          height: 40px;
          background: #f1f1f1;
          border-radius: 4px;
        }
        .item-textarea {
          height: 125px;
        }
      }
    }
    .info-item:last-child {
      margin-bottom: 0;
    }
  }
  .btn {
    height: 44px;
    background: #f31b27;
    border-radius: 24px;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .loading {
    position: absolute;
    left: 50%;
    top: 30%;
    transform: translate(-50%, -50%);
  }
}
</style>
